import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalProps } from '@context/ModalsContext'
import { useProductReadContext, useProductWriteContext } from '@context/ProductContext'

import { Modal } from '@ui/components/Modal'

import { useProductSwitchPath } from '@utils/path'

interface Props extends Pick<BaseModalProps, 'close'> {
  onAccept?: () => void
}

export const ProductSwitchModal: React.FC<Props> = (props) => {
  const { close, onAccept } = props
  const { t } = useTranslation()
  const { isDefaultCFDProductType } = useProductReadContext()
  const { changeProductContext } = useProductWriteContext()
  const { navigateToNextPath } = useProductSwitchPath()

  const handleProductSwitch = () => {
    const nextProduct = changeProductContext()
    navigateToNextPath(nextProduct)
  }

  const productSwitchConfirm = async () => {
    await close()
    handleProductSwitch()
    onAccept?.()
  }

  return (
    <Modal>
      <Modal.Header>
        {t('Switch from', {
          to: isDefaultCFDProductType() ? 'Futures' : 'CFD',
          from: isDefaultCFDProductType() ? 'CFD' : 'Futures',
        })}
      </Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('Are you sure you want to switch', {
            to: isDefaultCFDProductType() ? 'Futures' : 'CFD',
          })}
        </Modal.Body.Text>
        <Modal.Body.Text>
          {t('Note: Your funds are not transferable between Futures and CFDs Client Areas')}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={productSwitchConfirm}>{t('Confirm')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
